import * as React from 'react'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import FindInPageIcon from '@mui/icons-material/FindInPage'
import Document from './../../../assets/icons/document.png'

import UpArrow from './../../../assets/icons/arrowup.png'
import DownArrow from './../../../assets/icons/down-filled-triangular-arrow.png'
import { useEffect, useState } from 'react'
import { IconButton } from '@mui/material'

import ediPencil from './../../../assets/icons/editPencil.png'

import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify'




const columns = [
  { id: 'rank', label: 'Rank', minWidth: 100 },
  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'description', label: 'Description', minWidth: 170 },
  { id: 'action', label: 'Action', minWidth: 100 },
]


// function createData(id, rank, name, description) {
//     return { id, rank, name, description };
//   }

function createData(id, rankOrder, name, description) {
  return { id, rankOrder, name, description };
}
function EditInstructionTable(props) {
    const [DefaultInstructionData, setDefaultInstructionData]=useState([])
   
  const apiAddress = process.env.REACT_APP_SECRET;
  const [rows, setRows] = useState([])

  const deleteRow=(row)=>{
    console.log(row)
    if(row.id){
      axios
      .put(
        apiAddress + "/api/FoodItems/FoodItemInstructionDelete?InstructionId=" + row.id
      )
      .then((response) => {
        toast.error("Food Instruction Deleted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        var temp=[...rows]
        var index=temp.indexOf(row)
        var spliceData=temp.splice(index,1)
        console.log(spliceData)
        console.log(temp)
        temp.map((d,i)=>{
          d.rankOrder=i+1
        })
      
        setRows(temp)
      });
  }
}
    
  useEffect(() => {
   
    if(props.Name!== '' && props.Description!==''){
      const newRow = createData(props.Id?props.Id:'N/A',props.Rank?props.Rank:rows.length + 1, props.Name, props.Description)
      setRows([...rows, newRow])
    }
 
    
  }, [props.Name, props.Description])

   
useEffect(()=>{
    
  console.log(DefaultInstructionData)
    if(DefaultInstructionData.length>0){
  
      const sortedRows = [...DefaultInstructionData].sort((a, b) => a.rankOrder - b.rankOrder);
    var fetchedRows = sortedRows.map((item,i)=>{
      console.log(item.rankOrder)
      return createData(item.id, item.rankOrder, item.name, item.description)
    })
    
    setRows(fetchedRows);
   
  }
  
  },[DefaultInstructionData])

  useEffect(()=>{
    props.sendToInstruction(rows)
    props.sendInstructionToAdditem(rows)
    
  },[rows])

  useEffect(()=>{
    
    
    
    console.log(props.defaultData)
    setDefaultInstructionData(props.defaultData)
  },[props.defaultData])
  const handleRankChange = (index, action) => {
    const updatedRows = [...rows]
    const currentRow = updatedRows[index]
    let targetIndex

    if (action === 'increase' && index > 0) {
      targetIndex = index - 1
    } else if (action === 'decrease' && index < rows.length - 1) {
      targetIndex = index + 1
    } else {
      return 
    }

    const targetRow = updatedRows[targetIndex]
    const currentRank = currentRow.rankOrder
    const targetRank = targetRow.rankOrder

    currentRow.rankOrder = targetRank
    targetRow.rankOrder = currentRank

    updatedRows[index] = targetRow
    updatedRows[targetIndex] = currentRow

    setRows(updatedRows)
  }
  
  const handleEditRow=(id,name,description,rank)=>{
    
    props.sendForEdit(id,name,description,rank)
   }
 
   console.log(rows)
  
  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow >
                
                {columns.map((column) => (
                  <TableCell
                  sx={{backgroundColor:'#e2eaee'}}
                    key={column.id}
                    align="center"
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            
            <TableBody>
              
                
            {rows.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.rankOrder}
                    >
                      <TableCell align="center">
                      <IconButton
                          disabled={index === 0}
                          onClick={() => handleRankChange(index, 'increase')}
                        >
                          <ArrowUpwardIcon />
                        </IconButton>
                        {row.rankOrder}
                        <IconButton
                          disabled={index === rows.length - 1}
                          onClick={() => handleRankChange(index, 'decrease')}
                        >
                          <ArrowDownwardIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="center">
                        {row.name}
                        {row.id!='N/A'?(
                        <IconButton
                        onClick={() => handleEditRow(row.id,row.name,row.description,row.rankOrder)} 
                        >
                          <img src={ediPencil} style={{width:'1rem'}} /> 
                        </IconButton>
                        ):""}
                        </TableCell>
                      <TableCell align="center">{row.description}</TableCell>
                      <TableCell align="center">
                          
                          <div>
                              <span onClick={() => { deleteRow(row) }}>Delete</span>
                          </div>
                                              
                                          
                   </TableCell>
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>
        </TableContainer>
        
      </Paper>
    </>
  )
}

export default EditInstructionTable
